import {
  ApiBlueprint,
  configApiRef,
  createFrontendPlugin,
  discoveryApiRef,
  microsoftAuthApiRef,
  PageBlueprint,
  PluginHeaderActionBlueprint,
} from '@backstage/frontend-plugin-api';
import MegatronIcon from '../landing-page/MXPSidebarLogoIcon';
import {
  ProductMetaApiClient,
  productMetaApiRef,
} from '../product-meta/apis/product.api';
import { landingPageRouteRef, productMetaRouteRef } from '../routes';

const landingPage = PageBlueprint.make({
  name: 'landing-page',
  params: {
    path: '/megatron/landingpage',
    title: 'Megatron',
    icon: <MegatronIcon />,
    routeRef: landingPageRouteRef,
    loader: () =>
      import('../landing-page/MegatronLandingPage').then(m => (
        <m.MegatronLandingPage />
      )),
  },
});

const productMetaPage = PageBlueprint.make({
  name: 'product-meta',
  params: {
    path: '/megatron/product-meta',
    title: 'Megatron 1 Products',
    icon: <MegatronIcon />,
    routeRef: productMetaRouteRef,
    loader: () =>
      import('../product-meta/components/RootComponent/RootComponent').then(
        m => <m.RootComponent />,
      ),
  },
});

/** The signed-in Microsoft account in the header of the product pages. */
const productMetaProfile = PluginHeaderActionBlueprint.make({
  name: 'product-meta-profile',
  params: {
    loader: () =>
      import('../product-meta/components/ProductMetaProfile/ProductMetaProfile').then(
        m => <m.ProductMetaProfile />,
      ),
  },
});

const productMetaApi = ApiBlueprint.make({
  name: 'productMetaApi',
  params: defineParams =>
    defineParams({
      api: productMetaApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        microsoftAuthApi: microsoftAuthApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, microsoftAuthApi, configApi }) =>
        new ProductMetaApiClient(discoveryApi, microsoftAuthApi, configApi),
    }),
});

export default createFrontendPlugin({
  pluginId: 'megatron',
  routes: {
    landingPage: landingPageRouteRef,
    productMeta: productMetaRouteRef,
  },
  extensions: [
    landingPage,
    productMetaApi,
    productMetaPage,
    productMetaProfile,
  ],
});
